import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'black-range-selector',
    templateUrl: './range-selector.component.html',
    styleUrls: ['./range-selector.component.css'],
    standalone: false
})
export class RangeSelectorComponent implements OnInit {

  min = 20;
  max = 200;

  constructor() {}

  ngOnInit(): void {
    console.log('Hello');


  }

  updateValue(){
    // console.log(e);
    console.log('Hello');
  }

}
